module.exports = __webpack_public_path__ + "media/images/icons/share-efdc5357281e48c16bda4fd17bef7857.svg";